import { TweenMax, TimelineMax, Expo, Power2 } from 'gsap'
import SplitText from '@/assets/lib/SplitText'


const transition = (ctx, callback) => {
  const tl = new TimelineMax({ onComplete: callback })
  const title = ctx.$el.querySelector('[data-anim-enter="title"]')
  title.setAttribute('data-animated', '')
  const txt = ctx.$el.querySelector('[data-anim-enter="fade"]')
  txt.setAttribute('data-animated', '')
  const split = new SplitText(title, { type: 'words, chars', charsClass: 'title-chars' })
  const image = ctx.$el.querySelector('[data-anim-enter="image"]')

  tl
    .addLabel('start')
    .set('#smoothie', {
      autoAlpha: 1,
      y: 0
    }, 'start')
    .staggerFrom(split.chars, 1, {
      yPercent: 60,
      rotationZ: 20,
      rotationY: 80,
      autoAlpha: 0,
      ease: Expo.easeInOut
    }, 0.03, 'start+=0.2')
    .from(txt, 1, {
      yPercent: 75,
      autoAlpha: 0,
      ease: Power2.easeOut
    }, 'start+=0.6')
    .add(() => {
      let tween = () => {}

      if (image !== null) {
        tween = TweenMax.fromTo(image, 1, {
          autoAlpha: 0
        }, {
          autoAlpha: 1,
          ease: Expo.easeInOut
        })
      }

      return tween
    }, 'start+=0.6')

  return tl
}

export default transition



// WEBPACK FOOTER //
// ./src/scripts/transitions/fadeIn.js